export default __webpack_public_path__ + "static/01 - Foto Dario Sacco_SMALL-77011a5b781115b88d8c7eae63c589d4.png";